var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKavak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#757575;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.4,0l-18,29.87,18,29.87h15.6l-17.7-29.87L255,0h-15.6Zm-37.2,0V49.87L173.1,0l-35.1,59.73h15.3l19.8-33.33,8.4,14.13h-8.4l-6,9.87h20.1l5.4,9.33h24V0h-14.4Zm-57.9,0l-19.8,33.6L104.7,0h-15.3l35.1,59.73L159.6,0h-15.3ZM76.2,0l-29.4,49.87-11.7-20L52.8,0h-15.6L19.2,29.87l18,29.87h19.2l5.4-9.33h20.1l-6-9.87h-8.4l8.4-14.13,19.5,33.6h15.3L76.2,0ZM0,59.73H14.4V0H0V59.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKavak);
export default __webpack_public_path__ + "static/media/kavak.b6ab950367194e2ab11951079fc2f078.svg";
export { ForwardRef as ReactComponent };